var angular = require('angular');

var loggingModule = angular.module('ike.services.logging', []);
var ErrorStackParser = require('error-stack-parser');

loggingModule.provider('LogEntries', function() {
    var LogEntries = require('@ikegps/angular-logging-logentries');
    return {
        init: function(key) {
            LogEntries.init({
                token: key,
                trace: false
            });
        },
        $get: function() {
            return LogEntries;
        }
    };

});

// Wrap up stacktrace-js
loggingModule.factory('traceService', function() {
    return ({
        print: ErrorStackParser.parse.bind(ErrorStackParser)
    });
});

// Override angularjs logging service provider
loggingModule.provider('$exceptionHandler', function() {

    return {
        $get: ['exceptionLoggingService',
            function(exceptionLoggingService) {
                return (exceptionLoggingService);
            }
        ]
    };
});

function whatBrowser() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/);
        if (tem != null) {
            return 'Opera ' + tem[1];
        }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }
    return M.join(' ');
}

// Replace exception logging service to do the default behaviour but also to our logging repo
loggingModule.factory('exceptionLoggingService', ['$log', 'traceService', 'logRepository',
    function($log, traceService, logRepository) {

        function error(exception, cause) {
            $log.error.apply($log, arguments);
            try {
                // Get a stacktrace from stacktrace-js
                var stackTrace = traceService.print(exception);
                logRepository.put(exception.toString(), 'exception', stackTrace, (cause || ''));

            } catch (loggingError) {
                $log.warn('Error logging to log repository failed');
                $log.log(loggingError);
            }
        }
        return (error);
    }
]);

loggingModule.factory('logRepository', ['$window', '$injector', '$log', 'LogEntries',

    function($window, $injector, $log, LogEntries) {
        var usernameService;

        function getUsernameService() {
            try {
                usernameService = $injector.get('username');
            } catch (e) {
                $log.log('Warning, no username service. Exceptions will be logged with no username');
            }
        };

        function put(message, type, stackTrace, cause) {
            if (!usernameService) {
                getUsernameService();
            }

            LogEntries.log({
                user: usernameService ? usernameService.get() || 'no user' : 'no user',
                browser: whatBrowser(),
                url: $window.location.href,
                message: message,
                type: type,
                stackTrace: stackTrace,
                cause: cause
            });
        }
        return ({
            put: put
        });

    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/ike.services.logging.js
// module id = 386
// module chunks = 0